import { Route, Redirect, RouteProps } from 'react-router-dom'
import { useAuth } from '@/context/AuthContext'

export default function ProtectedRoute({ component: Component, render, ...rest }: RouteProps) {
  const { user, loading } = useAuth()

  return (
    <Route
      {...rest}
      render={(props) => {
        if (loading) {
          return (
            <div className="min-h-screen flex items-center justify-center">
              <p className="spec-label">Preheating…</p>
            </div>
          )
        }

        if (!user) {
          return <Redirect to="/login" />
        }

        if (Component) return <Component {...props} />
        if (render) return render(props)
        return null
      }}
    />
  )
}
